export default __webpack_public_path__ + "static/media/hotellerie.7ddadf2d.svg";